import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { UserHttpService } from 'apps/website/src/app/utils/common-services';
import { ModifiedActionStatus, PermissionValue } from 'apps/website/src/app/utils/enums';
import { UserType } from 'apps/website/src/app/utils/enums/usertype.enums';
import { UserSessionResponse } from 'apps/website/src/app/utils/interfaces';
import { DataFieldType } from '../../../common-ui/table-ui/table-ui.component';

@Component({
  selector: 'intrasense-table-action-buttons',
  templateUrl: './table-action-buttons.component.html',
  styleUrls: ['./table-action-buttons.component.scss']
})
export class TableActionButtonsComponent implements OnInit {
  @Input('row') row: any;
  @Input('item') item: any;
  @Input('index') i: any;
  @Output() onBtnClick = new EventEmitter();
  ACTION_EVENT = ModifiedActionStatus;
  PermissionValue = PermissionValue;
  userDetail!: UserSessionResponse;
  userType = UserType;
  constructor(private userHttpService: UserHttpService) { }

  ngOnInit(): void {
    this.userDetail = this.userHttpService.getUserInfo;
  }

  click(index: number, type: DataFieldType, actionEvent: string) {
    this.onBtnClick.emit({index$: index, type$: type, actionEvent$: actionEvent})
  }
}
